<div class="landing-page">
  <!-- Header -->
  <header class="landing-header">
    <div class="header-container">
      <div class="header-content" [class.authenticated]="authService.isAuthenticated()">
        <h1>ProTyco</h1>
        <p>
          <span style="color: oklch(51% 0.28 263.83);">PRO</span>PERTY <span style="color: oklch(51% 0.28 263.83);">TYCO</span>ON
        </p>
      </div>
      <nav class="auth-links">
        @if (!authService.isAuthenticated()) {
          <a href="/register" class="auth-link auth-link-primary">Registrieren</a>
          <a href="/login" class="auth-link">Anmelden</a>
        } @else {
          <div class="user-menu-container">
            <div class="user-status" [title]="authService.user()?.email ?? ''">✅ Angemeldet {{ authService.user()?.email }}</div>
            <button class="menu-trigger" (click)="toggleUserMenu()" [attr.aria-expanded]="showUserMenu()">
              <svg class="profile-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="8" r="4"></circle>
                <path d="M 6 20 Q 6 14 12 14 Q 18 14 18 20"></path>
              </svg>
            </button>
            
            @if (showUserMenu()) {
              <div class="menu-dropdown">
                <button class="menu-item" (click)="onCalculation()">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                    <rect x="6" y="4" width="12" height="4"></rect>
                    <line x1="6" y1="10" x2="18" y2="10"></line>
                    <line x1="6" y1="14" x2="18" y2="14"></line>
                    <line x1="6" y1="18" x2="18" y2="18"></line>
                  </svg>
                  Kalkulation durchführen
                </button>
                <button class="menu-item" (click)="onSubscriptionManagement()">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 9h12M6 9a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2M6 9v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9M9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2H9V5Z"></path>
                  </svg>
                  Abonnement-Verwaltung
                </button>
                <button class="menu-item" (click)="onChangePassword()">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="7" cy="12" r="4"></circle>
                    <path d="M11 12h9M20 9v6"></path>
                  </svg>
                  Passwort ändern
                </button>
                <button class="menu-item logout-item" (click)="onLogout()">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  <div class="logout-content">
                    <span class="logout-text">Abmelden</span>
                    <span class="logout-email">{{ authService.user()?.email }}</span>
                  </div>
                </button>
              </div>
            }
          </div>
        }
      </nav>
    </div>
  </header>

  <div class="landing-scroll">
  <!-- Hero Section -->
  <section class="hero">
    <div class="hero-content">
      <p class="hero-subtitle"><strong>ProTyco</strong> - Der professionelle Immobilien-Rechner mit Künstlicher Intelligenz für fundierte Investitionsentscheidungen</p>
      <div class="hero-actions">
        <button class="btn btn-primary" (click)="navigateToRegister('trial')">
          24h kostenlos testen
        </button>
        <button class="btn btn-secondary" (click)="scrollToPricing()">
          Preise ansehen
        </button>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features">
    <div class="container">
      <h2 class="section-title">Funktionen</h2>
      <div class="features-grid">
        @for (feature of features(); track feature.id) {
          <div class="feature-card" (click)="showFeatureDetails(feature)">
            <div class="feature-icon">{{ feature.icon }}</div>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.shortDescription }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- Pricing Section -->
  <section id="pricing" class="pricing">
    <div class="container">
      <h2 class="section-title">Preise</h2>
      <p class="section-subtitle">Wählen Sie das passende Paket für Ihre Bedürfnisse</p>
      
      @if (loading()) {
        <div class="loading-spinner">Lade Preise...</div>
      } @else {
        <div class="pricing-grid">
          @for (plan of plans(); track plan.planKey) {
            <div class="pricing-card" [class.featured]="plan.isPopular" (click)="showPlanDetails(plan)">
              @if (plan.isPopular) {
                <div class="badge">Beliebt</div>
              }
              <h3 class="plan-name">{{ plan.name }}</h3>
              <div class="plan-price">
                <span class="price-amount">{{ (plan.priceEUR | number:'1.2-2')?.replace('.', ',') }}€</span>
                @if (plan.durationMonths && plan.durationMonths > 0) {
                  <span class="price-period">/ {{ plan.durationMonths }} Monat{{ plan.durationMonths > 1 ? 'e' : '' }}</span>
                } @else if (plan.durationHours && plan.durationHours > 0) {
                  <span class="price-period">/ {{ plan.durationHours }}h</span>
                }
              </div>
              @if (plan.discountPercent && plan.discountPercent > 0) {
                <div class="discount-badge">{{ plan.discountPercent }}% Rabatt</div>
              } @else {
                <div class="discount-badge-spacer"></div>
              }
              <p class="plan-description">{{ plan.description }}</p>
              <button class="btn btn-primary" (click)="selectPlan(plan); $event.stopPropagation()">
                Jetzt starten
              </button>
            </div>
          }
        </div>
      }
    </div>
  </section>

  <app-footer></app-footer>
  </div>

  @if (showPlanDetailModal() && selectedPlanDetail()) {
    <app-pricing-detail-modal
      [planDetail]="selectedPlanDetail()!"
      (close)="closePlanDetailModal()"
      (selectPlan)="selectPlanFromModal($event)"
    ></app-pricing-detail-modal>
  }

  @if (showFeatureDetailModal() && selectedFeature()) {
    <app-feature-detail-modal
      [feature]="selectedFeature()!"
      (close)="closeFeatureDetailModal()"
    ></app-feature-detail-modal>
  }

  @if (showCheckout()) {
    <app-checkout
      [plan]="selectedPlan()!"
      [visible]="showCheckout()"
      (closed)="closeCheckout()"
    ></app-checkout>
  }
</div>
